import React, {Fragment} from 'react';
import {labelStyle, errorStyle} from './styles/ValidationInput.css';

const ValidationTextArea = ({
                           input,
                           label,
                           type,
                           val,
                           matchValue,
                           mismatchMessage,
                           otherTouched,
                           disabled,
                           meta: { touched, error }
                         }) => {
  const errorSpan = () => {
    let errorMessage = '';
    if (touched && error) {
      errorMessage = error;
    } else if (touched && otherTouched && val !== matchValue) {
      errorMessage = mismatchMessage;
    }
    return <span style={errorStyle}>{errorMessage}</span>;
  };

  return (
    <Fragment>
      <span style={labelStyle}>{label}</span>
      <textarea
        {...input}
        className={`form-control ${
          touched && (error || (otherTouched && val !== matchValue))
            ? 'alert-danger'
            : null
          }`}
        type={type}
        autoComplete="off"
        disabled={disabled}
      />
      {errorSpan()}
    </Fragment>
  );
};

export default ValidationTextArea;
